const Password = {
  WEAK_HMTL:
    'La contraseña es muy debil, recuerda que debe de tener: <ul><li>Minimo de 8 caracteres</li><li>Una mayuscula</li><li>Un caracter alfanumerico</li></ul>',
  MUSTMATCH_HTML: 'Las contraseñas no coinciden',
  REGEX: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*\W)[a-zA-Z\d\W]{8,}$/,
};

export default Password;
